import { CloseIcon, SearchIcon } from '@panwds/icons';
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { LoadingIcon } from '../Icon/index.js';
import { Input } from '../Input/index.js';
export const SearchInput = (props) => {
    const { isLoading, filter, filterItems, getInputProps } = props;
    const inputRef = useRef(null);
    const intl = useIntl();
    return (React.createElement("div", { className: "twds-p-1" },
        React.createElement(Input, { tabIndex: -1, "data-testid": "search-input", placeholder: intl.formatMessage({
                defaultMessage: 'Search',
                id: 'oPXkY9',
                description: 'Placeholder for search input'
            }), suffix: React.createElement("div", { className: "twds-flex twds-items-center twds-justify-center twds-pr-3 twds-h-full" },
                isLoading && React.createElement(LoadingIcon, null),
                filter ? (React.createElement("button", { type: "button", "aria-label": intl.formatMessage({
                        defaultMessage: 'Clear Filter',
                        id: '9/b2iN',
                        description: 'Label for button to clear filter input'
                    }), onClick: () => {
                        filterItems();
                        inputRef?.current?.focus();
                    }, className: "focus:twds-outline-none twds-box-border twds-border-0 twds-bg-transparent" },
                    React.createElement(CloseIcon, { size: "xxs", className: "twds-text-secondary dark:twds-text-dark-bg-secondary" }))) : (React.createElement(SearchIcon, { size: "sm", className: "twds-text-secondary dark:twds-text-dark-bg-secondary" }))), ...getInputProps({
                onChange: (event) => {
                    filterItems(event.target.value ?? '');
                },
                ref: inputRef
            }) })));
};
//# sourceMappingURL=SearchInput.js.map